module.exports = {"pageTitleText":"系统日志","message":"內容","level":"等级","category":"类型","timestamp":"时间"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/systemLog.json
// module id = 06T6
// module chunks = 3